import { List, SxProps, Theme, useTheme } from "@mui/material";
import { MenuItem } from "services/facultyPortalClient";
import { matchPath, useLocation } from "react-router-dom";
import { LeftMenuItem, LeftMenuLoader } from "@knowfully/ui.common";

const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  itemList: {
    py: 0,
  },
});

type LeftMenuItemListProps = {
  menuItems?: MenuItem[];
  currentMenuItem?: MenuItem;
  onClick?: (menuItem: MenuItem) => void;
};

export default function LeftMenuItemList({
  menuItems,
  currentMenuItem,
  onClick,
}: LeftMenuItemListProps) {
  const styles = getStyles(useTheme());
  const location = useLocation();

  const isCurrent = (menuItem: MenuItem): boolean | undefined => {
    const isPathMatching = (path: string, target: string) =>
      !!matchPath({ path, caseSensitive: false, end: false }, target);

    const isParentOrCurrentItem =
      currentMenuItem?.parentId === menuItem.id ||
      currentMenuItem?.id === menuItem.id;

    const isMenuItemMatch = isPathMatching(menuItem.url, location.pathname);

    const result = isParentOrCurrentItem || isMenuItemMatch;

    return result || undefined;
  };

  return (
    <nav>
      <List sx={styles.itemList}>
        {menuItems ? (
          menuItems.map((item) => (
            <LeftMenuItem
              key={item.name}
              label={item.name}
              icon={<i className={item.icon} aria-hidden="true" />}
              path={item.url}
              divider={true}
              title={item.toolTip}
              isCurrent={isCurrent(item)}
              onClick={() => onClick?.(item)}
            />
          ))
        ) : (
          <LeftMenuLoader />
        )}
      </List>
    </nav>
  );
}
